const constants = require('./constants');

const BACKGROUND_FILL_STYLE = '#000';
const PILL_FILL_STYLE = '#E9E9E9'; // '#FFF';
const BISCUIT_FILL_STYLE = '#E9E9E9';
const WALL_STROKE_STYLE = '#70E250';

const Map = function (size) {
  let height = null;
  let width = null;
  const blockSize = size;
  let pillSize = 0;
  let map = null;

  function withinBounds(y, x) {
    return y >= 0 && y < height && x >= 0 && x < width;
  }

  function isWall(pos) {
    return withinBounds(pos.y, pos.x) && map[pos.y][pos.x] === constants.WALL;
  }

  function isFloorSpace(pos) {
    if (!withinBounds(pos.y, pos.x)) {
      return false;
    }
    const peice = map[pos.y][pos.x];
    return peice === constants.EMPTY ||
      peice === constants.BISCUIT ||
      peice === constants.PILL;
  }

  function drawWall(ctx) {
    let p,
      line;

    ctx.strokeStyle = WALL_STROKE_STYLE;
    ctx.lineWidth = 5;
    ctx.lineCap = 'round';

    for (let i = 0; i < constants.WALLS.length; i += 1) {
      line = constants.WALLS[i];
      ctx.beginPath();

      for (let j = 0; j < line.length; j += 1) {
        p = line[j];

        if (p.move) {
          ctx.moveTo(p.move[0] * blockSize, p.move[1] * blockSize);
        } else if (p.line) {
          ctx.lineTo(p.line[0] * blockSize, p.line[1] * blockSize);
        } else if (p.curve) {
          ctx.quadraticCurveTo(p.curve[0] * blockSize,
            p.curve[1] * blockSize,
            p.curve[2] * blockSize,
            p.curve[3] * blockSize);
        }
      }
      ctx.stroke();
    }
  }

  function reset() {
    // @TM: Hard-coded resetting the map to avoid .clone();
    // map    = Pacman.MAP.clone();
    map = [
      [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      [0, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 0],
      [0, 4, 0, 0, 1, 0, 0, 0, 1, 0, 1, 0, 0, 0, 1, 0, 0, 4, 0],
      [0, 1, 0, 0, 1, 0, 0, 0, 1, 0, 1, 0, 0, 0, 1, 0, 0, 1, 0],
      [0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0],
      [0, 1, 0, 0, 1, 0, 1, 0, 0, 0, 0, 0, 1, 0, 1, 0, 0, 1, 0],
      [0, 1, 1, 1, 1, 0, 1, 1, 1, 0, 1, 1, 1, 0, 1, 1, 1, 1, 0],
      [0, 0, 0, 0, 1, 0, 0, 0, 1, 0, 1, 0, 0, 0, 1, 0, 0, 0, 0],
      [2, 2, 2, 0, 1, 0, 1, 1, 1, 1, 1, 1, 1, 0, 1, 0, 2, 2, 2],
      [0, 0, 0, 0, 1, 0, 1, 0, 0, 3, 0, 0, 1, 0, 1, 0, 0, 0, 0],
      [2, 2, 2, 2, 1, 1, 1, 0, 3, 3, 3, 0, 1, 1, 1, 2, 2, 2, 2],
      [0, 0, 0, 0, 1, 0, 1, 0, 0, 0, 0, 0, 1, 0, 1, 0, 0, 0, 0],
      [2, 2, 2, 0, 1, 0, 1, 1, 1, 2, 1, 1, 1, 0, 1, 0, 2, 2, 2],
      [0, 0, 0, 0, 1, 0, 1, 0, 0, 0, 0, 0, 1, 0, 1, 0, 0, 0, 0],
      [0, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 0],
      [0, 1, 0, 0, 1, 0, 0, 0, 1, 0, 1, 0, 0, 0, 1, 0, 0, 1, 0],
      [0, 4, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 4, 0],
      [0, 0, 1, 0, 1, 0, 1, 0, 0, 0, 0, 0, 1, 0, 1, 0, 1, 0, 0],
      [0, 1, 1, 1, 1, 0, 1, 1, 1, 0, 1, 1, 1, 0, 1, 1, 1, 1, 0],
      [0, 1, 0, 0, 0, 0, 0, 0, 1, 0, 1, 0, 0, 0, 0, 0, 0, 1, 0],
      [0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0],
      [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    ];
    height = map.length;
    width = map[0].length;
  }

  function block(pos) {
    return map[pos.y][pos.x];
  }

  function setBlock(pos, type) {
    map[pos.y][pos.x] = type;
  }

  function drawPills(ctx) {
    if (++pillSize > 30) {
      pillSize = 0;
    }

    for (let i = 0; i < height; i += 1) {
      for (let j = 0; j < width; j += 1) {
        if (map[i][j] === constants.PILL) {
          ctx.beginPath();

          ctx.fillStyle = BACKGROUND_FILL_STYLE;
          ctx.fillRect((j * blockSize), (i * blockSize),
            blockSize, blockSize);

          ctx.fillStyle = PILL_FILL_STYLE;
          ctx.arc((j * blockSize) + blockSize / 2,
            (i * blockSize) + blockSize / 2,
            Math.abs(5 - (pillSize / 3)),
            0,
            Math.PI * 2, false);
          ctx.fill();
          ctx.closePath();
        }
      }
    }
  }

  function draw(ctx) {
    let i,
      j,
      size = blockSize;

    ctx.fillStyle = BACKGROUND_FILL_STYLE;
    ctx.fillRect(0, 0, width * size, height * size);

    drawWall(ctx);

    for (i = 0; i < height; i += 1) {
      for (j = 0; j < width; j += 1) {
        drawBlock(i, j, ctx);
      }
    }
  }

  function drawBlock(y, x, ctx) {
    const layout = map[y][x];

    if (layout === constants.PILL) {
      return;
    }

    ctx.beginPath();

    if (layout === constants.EMPTY || layout === constants.BLOCK || layout === constants.BISCUIT) {
      ctx.fillStyle = BACKGROUND_FILL_STYLE;
      ctx.fillRect((x * blockSize), (y * blockSize),
        blockSize, blockSize);

      if (layout === constants.BISCUIT) {
        ctx.fillStyle = BISCUIT_FILL_STYLE;
        ctx.fillRect((x * blockSize) + (blockSize / 2.5),
          (y * blockSize) + (blockSize / 2.5),
          blockSize / 6, blockSize / 6);
      }
    }
    ctx.closePath();
  }

  reset();

  return {
    draw,
    drawBlock,
    drawPills,
    block,
    setBlock,
    reset,
    isWall,
    isFloorSpace,
    height,
    width,
    blockSize,
  };
};

module.exports = Map;



// WEBPACK FOOTER //
// ./_components/hero-halloween-block/map.js